import { Component } from '@angular/core';
import { ShowComponent } from '../../common/component/show.component';

@Component({
	selector: 'app-optional-trip',
	templateUrl: './optional-trip.component.html',
	styleUrls: ['./optional-trip.component.css'],
})
export class OptionalTripComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/optional_trip/';
	protected parentComponent = 'optionalTrip';
	optionalTrip = [];
	locations: Array<any> = [];
	isActiveOptions = [
		{ enum: false, name: 'Nieaktywna' },
		{ enum: true, name: 'Aktywna' },
	];
	checkSubmit = false;
	pageTitle = 'Wycieczki fakultatywne -> Dodawanie';
	pageFunction = 'edit';
	protected holdOptionalTripLocations;
	protected holdOptionalTripMultimedia;
	protected pageTitleGenerate(): string {
		return `Wycieczki fakultatywne ->
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		name: null,
		isActive: false,
		description: null,
		optionalTripMultimedia: [],
		optionalTripLocations: [],
	};

	protected submitBefore(): void {
		this.holdOptionalTripLocations = this.data.optionalTripLocations;
		this.data.optionalTripLocations = this.data.optionalTripLocations.map((item, index) => {
			return {
				id: item.id,
				location: item.location.id,
				order: index,
			};
		});
		this.holdOptionalTripMultimedia = this.data.optionalTripMultimedia;
		this.data.optionalTripMultimedia = this.data.optionalTripMultimedia.map((item, index) => {
			return {
				id: item.id,
				multimedia: item.multimedia.id,
				order: index,
			};
		});
	}

	protected submitAfter(): void {
		if (this.checkSubmit == true) {
			this.data.optionalTripLocations = this.holdOptionalTripLocations;
			this.data.optionalTripMultimedia = this.holdOptionalTripMultimedia;
		} else {
			this.router.navigate([this.parentComponent]);
		}
	}

	protected convertData(data: any) {
		data.optionalTripLocations.forEach((obj) => {
			if (obj.location.locationKind === 'RG') {
				obj.location.locationKind = 'Region';
			} else if (obj.location.locationKind === 'CT') {
				obj.location.locationKind = 'Miasto';
			} else if (obj.location.locationKind === 'CR') {
				obj.location.locationKind = 'Państwo';
			}
			obj.order++;
		});
		data.optionalTripMultimedia.forEach((obj) => {
			obj.order++;
		});
		return data;
	}

	protected loadBefore(): void {
		this.bag.get('/optional_trip/?limit=9999', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.optionalTrip = result.results;
		});

		this.bag.get('/location/?limit=9999', (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}

			this.locations = result.results;
		});

		this.loadData();
	}

	protected back() {
		history.back();
	}

	protected submitAndStay() {
		this.checkSubmit = true;
		this.submit();
	}

	protected submitAndExit() {
		this.checkSubmit = false;
		this.submit();
	}

	protected getApiUrl(): string {
		return '/optional_trip/' + this.data.id + '/';
	}
}
